import * as React from 'react'
import { useRef } from 'react'
import { Interweave } from 'interweave'
import { UrlMatcher } from 'interweave-autolink'
import styled from 'styled-components'
import { Close } from 'svgIcons'
import { NewsItem_NewsItemEdgeFragment } from 'generated/graphql'
import getChannelOgData from '@app.feature/channel/module/getChannelOgData'
import { mobileBreakPoint } from 'app.styled/media'
import NewsItemCommentForm from '../../component/NewsItemCommentForm/NewsItemCommentForm'
import NewsCardCommentList from '../../component/NewsItemCommentList'
import NewsCardFooter from '../../component/NewsItemFooter/NewsItemFooter'
import NewsHeader from '../../component/NewsItemHeader/NewsItemHeader'
import NewsItemImageSlider from '../../component/NewsItemImageSlider'
import useTagEffect from '../../hook/useTagEffect'

type TProps = {
  data: Omit<NewsItem_NewsItemEdgeFragment, '__typename' | 'cursor'>
  onClose: (() => void) | undefined
  className?: string
}

const ScreenNewsItemModalDesktop: React.FC<TProps> = ({
  data,
  onClose,
  className,
}) => {
  const descriptionRef = useRef(null)
  useTagEffect(descriptionRef)

  const ogData = getChannelOgData({ data })

  return (
    <StyledWrapper className={className}>
      <div className="lt">
        <NewsItemImageSlider
          data={data.content?.images.nodes || []}
          type="modal"
        />
      </div>
      <div className="rt">
        <div className="close-btn" onClick={onClose}>
          <Close />
        </div>
        <NewsHeader data={data.header!} type="modal" showFollowBtn />
        <div className="modal-content">
          <div className="description" ref={descriptionRef}>
            <Interweave
              content={data.content?.content}
              matchers={[new UrlMatcher('url')]}
            />
          </div>
          <NewsCardCommentList
            type="modal"
            expendComment
            newsItemId={data.commentList?.id || ''}
            viewerIsAuthor={data.commentList?.viewerIsAuthor || false}
          />
        </div>
        <NewsCardFooter type="modal" data={data.footer!} ogData={ogData} />
        <div className="form">
          <NewsItemCommentForm
            expendComment
            newsItemId={data.commentForm?.id || ''}
            viewerCanReply={data.commentForm?.viewerCanReply || false}
          />
        </div>
      </div>
    </StyledWrapper>
  )
}

export default ScreenNewsItemModalDesktop

const StyledWrapper = styled.div`
  display: flex;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: transparent;
  border-radius: 10px;
  & > .lt {
    width: 800px;
    height: 800px;
    background-color: #333;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    overflow: hidden;
  }
  & > .rt {
    position: relative;
    width: 420px;
    height: 800px;
    background-color: white;
    overflow: visible;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
    .close-btn {
      color: white;
      cursor: pointer;
      position: absolute;
      top: 0;
      right: 0;
      transform: translate(150%, -100%);
    }
    .modal-content {
      width: 100%;
      flex-grow: 1;
      overflow-y: scroll;
      & > .description {
        padding: 0 20px 20px;
        min-height: 100px;
        a {
          color: rgb(1, 160, 255) !important;
        }
      }
    }
    .form {
      padding: 0 20px;
    }
  }
  ${mobileBreakPoint} {
    display: none;
  }
`
